export class EditPbaModalPayload {
  pbaId: number;
}
